const COLORS = {
  primary: '#eeeeeeff',
  primary_hover: '#eeeeeeff',
  blue: '#0a58ca',
  secondary: '#292929ff',
  brightred: '#E32D13',
  brightgreen: '#69B32D',
  orange: '#FFAC40',
  black: 'rgb(27, 27, 27)',
  grey : '#ecf0f1',
  grey_light : '#dfe7e7ff',
};


export default COLORS;
